import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translationEN from 'locales/en-GB.json'
import translationIS from 'locales/is.json'
import translationDK from 'locales/dk.json'
import translationSE from 'locales/se.json'
import translationES from 'locales/es.json'

// the translations
import i18next from 'i18next'

i18next.use(initReactI18next).init({
	lng: 'en',
	fallbackLng: 'en',
	debug: true,
	nsSeparator: false,
	resources: {
		en: {
			translation: translationEN
		},
		is: {
			translation: translationIS
		},
		dk: {
			translation: translationDK
		},
		se: {
			translation: translationSE
		},
		es: {
			translation: translationES
		}
	}
})

export default i18n
